import React from 'react';
import {Center, Loader, Stack, Title} from '@mantine/core';

interface LoadingProps {
    visible?: boolean;
    loadingMessage: string;
}

export const Loading: React.FC<LoadingProps> = ({visible = true, loadingMessage}) => {
    if (!visible) return null;

    return (
        <Center style={{height: '100%'}} hidden={!visible}>
            <Stack justify="center" align="center" gap={'sm'}>
                <Loader/>
                <Title style={{textAlign: 'center'}} order={4}>{loadingMessage}</Title>
            </Stack>
        </Center>
    );
};
